var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"type":"button","inert":_vm.disabled,"title":_vm.$t('Copy to clipboard').toString()},on:{"click":_vm.copyText}},[_vm._t("default",function(){return [_c('span',{staticClass:"inline-block relative w-1em h-1em"},[_c('SaIcon',{staticClass:"absolute left-0",attrs:{"name":"copy"}}),_vm._v(" "),_c('SaIcon',{staticClass:"absolute left-0",class:[
          _vm.copied ? 'opacity-100' : 'opacity-0',
          _vm.fade ? 'transition-opacity duration-1000' : '',
        ],attrs:{"name":"copy-solid"}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }